import styles from "./CommonCellRenderers.module.scss";
import React from "react";
import NotAvailableCellData from './NotAvailableCellData'

const CommonCellAtoms = {};

CommonCellAtoms.CtaButton = ({ children, isDisabled, ...rest }) => {
    return <button className={styles['cta']} disabled={isDisabled} {...rest}>
        {children}
    </button>
}

CommonCellAtoms.NotAvailableCellData = NotAvailableCellData;

export default CommonCellAtoms;